// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"style-primaryButton-20YZOo","athenaTable":"style-athenaTable-3inYC2"};